import PropTypes from 'prop-types';
import { hasActiveAnalysisStatus } from '../../helpers/Analysis';

export const DoesNotHaveActiveAnalysis = ({ analysis, children }) => {
    const status = (analysis && analysis.status) || null;
    return !hasActiveAnalysisStatus(status) ? children : null;
};

DoesNotHaveActiveAnalysis.propTypes = {
    analysis: PropTypes.string,
    children: PropTypes.node,
    'analysis.status': PropTypes.string,
};
